module.exports = __webpack_public_path__ + "static/media/slack.11ddd325.svg";